import React from 'react';
import { classNames } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import { colours, useTags } from '../../Data/Tags';
import { useDialogues } from '../Dialogues';
import { useSession } from '../Session';
import { Roles } from '../../Data/Users';

const baseClasses = 'inline-flex flex-row gap-1 rounded-full py-1 px-2 border items-center justify-between text-xs text-nowrap';

const Tag = ({tag, onClick, muted = false, icon = null, disabled = false, dismiss = null}) => {
    const {tags} = useTags();
    const {confirm} = useDialogues();
    const {isRoleSufficient} = useSession();

    if (!tags) {
        return <div className={classNames(
            baseClasses,
            'border-slate-400 fill-slate-400 text-slate-400 bg-slate-50',
        )}>
            <Icon icon="SquareQuestion" theme="solid" size="0.5x" />
            Tag
        </div>
    };

    const theTag = typeof tag === 'string' ? tags.find(t => t.id === tag) : tag;

    if (!theTag) {
        return null;
    }

    let theOnClick = onClick;
    let theIcon = icon;
    if (dismiss && (theTag.dismissible || isRoleSufficient(Roles.Manager))) {
        theOnClick = () => confirm(
            {
                theme: 'primary',
                title: 'Remove tag',
                message: `Are you sure you want to remove the "${theTag.name} tag?`,
                confirmText: 'Remove',
            },
            () => dismiss(theTag.id)
        );
        theIcon = 'XMark';
    }

    return <div className={classNames(
            baseClasses,
            (muted || disabled) ? 'bg-slate-50' : colours[theTag.colour].bgLight,
            (muted || disabled) ? colours[theTag.colour].borderMuted : colours[theTag.colour].border,
            colours[theTag.colour].fill,
            colours[theTag.colour].text,
            (theOnClick && !disabled) && 'cursor-pointer',
        )}
        onClick={() => (theOnClick && !disabled) && theOnClick()}
    >
        <Icon icon={theTag.icon} theme="solid" size="0.5x" />
        {theTag.name}
        {theIcon && <Icon icon={theIcon} theme="solid" size="0.5x" />}
    </div>
}

const NewTag = ({onClick, disabled}) => {
    return <div className={classNames(
        baseClasses,
        'border-dashed border-slate-400 fill-slate-400 text-slate-400 bg-slate-50',
        !disabled && 'cursor-pointer',
    )}
    onClick={() => (onClick && !disabled) && onClick()}
    >
        <Icon icon="Plus" theme="solid" size="0.5x" />
        New Tag
    </div>
}

export default Tag;

export { NewTag };